import axios, { type AxiosInstance, type AxiosRequestConfig } from 'axios'
import { clearAuth } from './auth'

const baseURL = import.meta.env.VITE_API_BASE_URL || '/api'

export const api: AxiosInstance = axios.create({
  baseURL,
  timeout: 30_000,
  headers: { 'Content-Type': 'application/json' },
})

// 鉴权拦截器（v1 单用户，从 localStorage 读 token）
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('fenxi_token')
  if (token) {
    config.headers.Authorization = `Basic ${token}`
  }
  return config
})

// 响应拦截器
api.interceptors.response.use(
  (resp) => resp,
  (error) => {
    if (error.response?.status === 401) {
      // 关键:401 意味着 token 失效(或被轮换),先清 localStorage
      // 否则 /login 页 useEffect 看到 fenxi_token 还在,isAuthed()=true,
      // 会立刻跳回原页面 → 死循环 / → /login → /
      clearAuth()
      if (window.location.pathname !== '/login') {
        window.location.href = '/login'
      }
    }
    return Promise.reject(error)
  },
)

/** 类型化的 GET */
export async function get<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
  const { data } = await api.get<T>(url, config)
  return data
}

/** 类型化的 POST */
export async function post<T>(url: string, body?: unknown, config?: AxiosRequestConfig): Promise<T> {
  const { data } = await api.post<T>(url, body, config)
  return data
}
